import React from 'react';

import ViewChanger from './ViewChanger';
import CreateDocument from './CreateDocument';
import CreateFolderButton from './CreateFolderButton';
import UploadFileButton from './UploadFileButton';

import { useUserDetailsContext } from 'context/userDetailsContext';
import constants from 'constants/index';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import Discrepancy from './Discrepancy';
import ExtractEntities from './ExtractEntities';
import CreateTimeline from './CreateTimeline';

function Menu() {
  const { isGlobalFileManager, isCaseFileManager, isLeadFileManager, isClientFileManager, isFirmDocuments } = useFileManagerContext();
  const { getPermission, checkSubPermission } = useUserDetailsContext();

  return (
    <div className="d-flex align-items-center flex-wrap gap-2">
      <ViewChanger />
      {checkSubPermission('ai_find_discrepancies') && (isCaseFileManager || isLeadFileManager) ? <Discrepancy /> : null}
      {(getPermission('cases') === constants.permissions.WRITE || isClientFileManager) && (
        <div className="font-bold d-flex align-items-center justify-content-end gap-2">
          {checkSubPermission('document_assembly') && !isGlobalFileManager && !isClientFileManager && <CreateDocument />}
          {(!isGlobalFileManager && !isClientFileManager) || isFirmDocuments ? <CreateFolderButton /> : null}
          {(isCaseFileManager || isClientFileManager || isLeadFileManager) && <UploadFileButton />}
        </div>
      )}
      {checkSubPermission('ai_extract_entities') ? !isGlobalFileManager && !isClientFileManager && <ExtractEntities /> : null}
      {checkSubPermission('ai_create_timeline') ? !isGlobalFileManager && !isClientFileManager && <CreateTimeline /> : null}
    </div>
  );
}

export default Menu;
